import Api from './Api';

export default {
	getTerms() {
		return Api.get('get_order_terms');
	},
	search(obj) {
		return Api.post('search', obj);
	},
	loadMore(arr) {
		const obj = {
			'ids': arr
		};
		return Api.post('load_more', obj);
	}
};
